module.exports = __webpack_public_path__ + "static/media/double-park-2-2.e12232df.jpg";